'use client';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
/**
 * Returns the user's preferred keyboard hint display style.
 *
 * - `'symbols'` (default): Unicode modifier symbols (⌘, ⇧, ⌃, ⌥)
 * - `'text'`: Full key names (Cmd, Shift, Ctrl, Opt / Alt on non-Mac)
 */
export function useKeyboardHintStyle() {
    const [style] = useLocalUserSettings('keyboardHintDisplay', undefined);
    return style ?? 'symbols';
}
//# sourceMappingURL=useKeyboardHintStyle.js.map